import { useContext } from 'react';
import { NextPage } from 'next';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import LayoutCompany from 'components/modules/public/layouts/Company';

import SectionArticles from './sections/Articles';
import SectionHero from './sections/Hero';
import SectionNewsletter from './sections/Newsletter';
import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticlesEmployerList: NextPage<Props> = ({ articles, cmsPage }) => {
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.employerArticlesList;

    return (
        <StyledComponent className="public-page-employer-articles">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle || data?.meta?.title}
                description={cmsPage?.metaDescription || data?.meta?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl || data?.meta?.image}
            />
            <LayoutCompany>
                <PageContainer>
                    <SectionHero {...data.content.hero} />
                    {/* <Search
                        search={{
                            translations: {
                                filters: {
                                    sort: {
                                        label: 'Sortuj:',
                                        options: {
                                            newest: 'Najnowsze',
                                            oldest: 'Najstarsze',
                                        },
                                    },
                                },
                            },
                            filters: filters,
                            onChangeFilters: (nextFilters) => {
                                setFilters({
                                    ...filters,
                                    ...nextFilters,
                                })
                            },
                            placeholder: 'Wyszukaj',
                        }}
                    /> */}
                    {Array.isArray(articles?.elements) && articles?.elements.length > 0 && (
                        <SectionArticles
                            {...data.content.sectionArticlesProps}
                            articles={articles.elements}
                            meta={articles.meta}
                        />
                    )}
                    <SectionNewsletter {...data.content.newsletter} />
                </PageContainer>
            </LayoutCompany>
        </StyledComponent>
    );
};

export default PublicPageArticlesEmployerList;
